/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdCalendarProps } from './type';

export const calendarDefaultProps: TdCalendarProps = {
  autoClose: true,
  confirmBtn: '',
  firstDayOfWeek: 0,
  title: '请选择日期',
  type: 'single',
  usePopup: true,
  visible: false,
};
